// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1x9j0","name":"ConsentHeader_name__1mW9Z","birthday":"ConsentHeader_birthday__5Y1U1","skeleton":"ConsentHeader_skeleton__2ejTF"};